import type { ReactNode } from 'react';

export const symbol_sports_cricket: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M579-390 479-290q-10 10-25.5 10T428-290L90-628q-10-10-10-23t10-23l100-100q10-10 25.5-13t25.5 7l338 338q10 10 10 26t-10 26Zm-125 41 66-66-302-302-66 66 302 302Zm273 243L573-260l44-44 154 154q9 9 9 22t-9 22q-9 9-22 9t-22-9Zm-68.5-551.5Q621-695 621-750t37.5-92.5Q696-880 751-880t92.5 37.5Q881-805 881-750t-37.5 92.5Q806-620 751-620t-92.5-37.5Zm142-43Q821-721 821-750t-20.5-49.5Q780-820 751-820t-49.5 20.5Q681-779 681-750t20.5 49.5Q722-680 751-680t49.5-20.5ZM751-750ZM336-533Z"
		/>
	</svg>
);
